import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import React from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

export default function CropPopUp({
  handleModalClose,
  cropModalOpen,
  handleCropImage,
  handleSaveFullImage,
  setCrop,
  crop,
  onCropComplete,
  onImageLoaded,
  file,
}) {
  return (
    <Dialog
      open={cropModalOpen}
      onClose={handleModalClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: "#000080",
          color: "#fff",
          fontSize: "20px",
          fontWeight: 600,
          py: 2,
          pl: 3,
          pr: 5,
        }}
      >
        Crop Image
        <IconButton
          aria-label="close"
          onClick={handleModalClose}
          sx={{
            position: "absolute",
            right: 12,
            top: 12,
            color: "#fff",
          }}
        >
          ×
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: 3 }}>
        {file && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "10px 0",
            }}
          >
            <ReactCrop
              crop={crop}
              onChange={(c) => setCrop(c)}
              onComplete={onCropComplete}
              aspect={undefined} // or simply remove this prop
            >
              <img
                src={file}
                onLoad={onImageLoaded}
                alt="Crop me"
                style={{
                  maxWidth: "100%",
                  maxHeight: "400px",
                  borderRadius: "8px",
                }}
                crossOrigin="anonymous"
              />
            </ReactCrop>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        {/* <Button onClick={handleModalClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleSaveFullImage}
          variant="contained"
          sx={{ backgroundColor: "#000080", color: "#fff" }}
        >
          Save Full Image
        </Button> */}
        <Button
          onClick={handleCropImage}
          variant="contained"
          sx={{ backgroundColor: "#000080", color: "#fff" }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
